const STORAGE_KEY = 'insights:storeHcPendingDeviceSearch';
const TTL_MS = 5 * 60 * 1000;

export type PendingStoreHcSearchedDevice = {
  deviceType: string;
  serialNumber?: string;
  deviceName?: string;
};

export type PendingStoreHcSearch = {
  siteId: string;
  selectedRegion: string | null;
  searchedDevice: PendingStoreHcSearchedDevice;
  ts: number;
};

export function writePendingStoreHcDeviceSearch(
  payload: Omit<PendingStoreHcSearch, 'ts'>
): void {
  try {
    const data: PendingStoreHcSearch = {...payload, ts: Date.now()};
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch {
    // quota / private mode
  }
}

export function clearPendingStoreHcDeviceSearch(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}

/** Read without removing — clear only after StoreHC applies the pending search. */
export function peekPendingStoreHcDeviceSearch(siteId: string): PendingStoreHcSearch | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw) as PendingStoreHcSearch;
    if (
      !parsed?.searchedDevice?.deviceType ||
      String(parsed.siteId) !== String(siteId)
    ) {
      return null;
    }
    if (Date.now() - (parsed.ts || 0) > TTL_MS) {
      sessionStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}
